'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var styledComponents = require('./styled-components.js');

var ConversationCard = function (props) {
    var body = props.body, sender = props.sender, timeStamp = props.timeStamp, status = props.status;
    var justify = status !== 'received' ? 'flex-end' : 'flex-start';
    var styledBody = status === 'canceled' ? React__default.createElement("s", null, body) : body;
    return (React__default.createElement(Grid, { container: true, justify: justify },
        React__default.createElement(Grid, { item: true, xs: 8 },
            React__default.createElement(styledComponents.StyledCard, null,
                status === 'pending' && React__default.createElement(styledComponents.StyledCircularProgress, { size: 20, thickness: 4 }),
                React__default.createElement(styledComponents.TitleTypography, null,
                    React__default.createElement("b", null, sender),
                    " ",
                    React__default.createElement(styledComponents.LightTextSpan, null, timeStamp.format('H:mm A'))),
                React__default.createElement(styledComponents.BodyTypography, { status: status }, styledBody)))));
};

module.exports = ConversationCard;
